import PropTypes from 'prop-types';
import React from 'react';
import TitledPanel from '../core/TitledPanel';
import BasicLanguageField from './BasicLanguageField';
import LangConfirmationField from './LangConfirmationField';

class BasicLanguageFieldDisplay extends React.Component {

    render() {

        const { isReadOnly, message, title, onePerLang, placeholder, maxLength, existingValues, tooltipText,
            defaultLang, property, values, projectLang, onUpdate, required, dataTest,
            onDelete, onAddLanguage, multiline, name } = this.props;

        // Data may include languages not in the project languages so exclude them from calculation
        const usedProjectLangs = projectLang.filter(lang => values ? Object.keys(values).includes(lang) : false);

        return (
            <TitledPanel dataTest={dataTest} height="full" title={title} actions=
                {!isReadOnly && onAddLanguage && !(onePerLang && values && usedProjectLangs.length >= projectLang.length) ?
                    <BasicLanguageField
                        dataTest={dataTest}
                        existingLangs={values ? Object.keys(values) : []}
                        multiline={multiline}
                        defaultLang={defaultLang}
                        tooltipText={tooltipText}
                        langs={projectLang}
                        placeholder={placeholder}
                        onePerLang={onePerLang}
                        existingValues={existingValues ?
                            existingValues
                            :
                            values}
                        title={message}
                        name={name}
                        onAddLanguage={onAddLanguage(property)}
                        maxLength={maxLength} />
                    :
                    null
                }>
                {values && Object.keys(values).sort().map((lang) => {
                    const langFields = Array.isArray(values[lang]) ? values[lang] : [values[lang]];
                    const existingLangFields = existingValues ?
                        Array.isArray(existingValues[lang]) ? existingValues[lang] : [existingValues[lang]]
                        :
                        Array.isArray(values[lang]) ? values[lang] : [values[lang]];
                    const canBeDeleted = !required || !(onePerLang && lang === defaultLang);
                    let positions = {};
                    langFields.forEach((text, i) => positions[text] = i);
                    return <div key={lang}>
                        {
                            langFields
                                .sort()
                                .map((text, index) =>
                                    <LangConfirmationField
                                        dataTest={dataTest + "-field-" + lang + '-' + index}
                                        key={lang + "-" + text}
                                        onUpdate={onUpdate(property, lang, Array.isArray(values[lang]) ? positions[text] : null)}
                                        onDelete={onDelete(property, lang)}
                                        existingValues={existingLangFields}
                                        focus={false}
                                        canBeDeleted={canBeDeleted}
                                        maxLength={maxLength || 500}
                                        multiline={multiline}
                                        text={text}
                                        lang={lang}
                                        isReadOnly={isReadOnly} />
                                )
                        }
                    </div>;
                }
                )}
            </TitledPanel>
        );
    }
}

BasicLanguageFieldDisplay.defaultProps = {
    multiline: false,
    required: true,
    onePerLang: false
};

BasicLanguageFieldDisplay.propTypes = {
    dataTest: PropTypes.string,
    onUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onAddLanguage: PropTypes.func,
    multiline: PropTypes.bool,
    values: PropTypes.object,
    // existingValues overrides values if supplied
    existingValues: PropTypes.object,
    name: PropTypes.string,
    isReadOnly: PropTypes.bool,
    placeholder: PropTypes.string,
    tooltipText: PropTypes.string,
    maxLength: PropTypes.number,
    required: PropTypes.bool,
    projectLang: PropTypes.array.isRequired,
    message: PropTypes.string,
    property: PropTypes.string.isRequired,
    onePerLang: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
};

export default BasicLanguageFieldDisplay;